/* ORRA: website to back office link.
   Every enquiry form (bespoke brief, piece request, private viewing, contact) gets:
   - a reference the client sees (ORRA-B / ORRA-V / ORRA-R / ORRA-C + 6 characters)
   - one line "ORRA data" that the back office reads when the email is pasted in.
   Nothing is sent anywhere new: the form still goes to the store's inbox through Shopify. */
(function () {
  'use strict';
  var AR = (document.documentElement.lang || '').slice(0, 2) === 'ar';
  var T = function (en, ar) { return AR ? ar : en; };
  var D = {}; try { D = JSON.parse(document.getElementById('A2Data').textContent); } catch (e) {}

  function saved() {
    var h = []; try { h = JSON.parse(localStorage.getItem('aura:wishlist')) || []; } catch (e) {}
    var P = D.products || [];
    return h.map(function (x) { var p = P.filter(function (q) { return q.h === x; })[0]; return p ? p.t : x; }).slice(0, 8);
  }
  function code(kind) {
    var k = /bespoke/i.test(kind) ? 'B' : /viewing|consult/i.test(kind) ? 'V' : /piece request/i.test(kind) ? 'R' : 'C';
    var r = (Date.now().toString(36) + Math.random().toString(36).slice(2, 4)).toUpperCase().slice(-6);
    return 'ORRA-' + k + '-' + r;
  }
  function hidden(f, name, val) {
    var i = f.querySelector('input[name="' + name + '"]');
    if (!i) { i = document.createElement('input'); i.type = 'hidden'; i.name = name; f.appendChild(i); }
    i.value = val; return i;
  }

  /* earliest selectable day is tomorrow; consultation buttons read "Book a private viewing" */
  document.querySelectorAll('[data-a2-mindate]').forEach(function (i) {
    var d = new Date(); d.setDate(d.getDate() + 1); i.min = d.toISOString().slice(0, 10);
  });
  document.querySelectorAll('[data-a2-request="consult"]').forEach(function (b) {
    if (!b.children.length) b.textContent = T('Book a private viewing', 'احجز معاينةً خاصّة');
  });

  /* the consultation request becomes a private-viewing booking; show which saved pieces we will prepare */
  document.addEventListener('click', function (e) {
    var any = e.target.closest && e.target.closest('[data-a2-request]'); if (!any) return;
    setTimeout(function () { var w = document.querySelector('[data-a2-req-when]'); if (w) w.querySelectorAll('input,select').forEach(function (i) { i.disabled = w.hidden; }); }, 70);
    var b = any.getAttribute('data-a2-request') === 'consult' ? any : null; if (!b) return;
    setTimeout(function () {
      var m = document.querySelector('[data-a2-modal="request"]'); if (!m) return;
      var q = function (s) { return m.querySelector(s); };
      if (q('[data-a2-req-label]')) q('[data-a2-req-label]').textContent = T('Private viewing', 'معاينةٌ خاصّة');
      if (q('[data-a2-req-text]')) q('[data-a2-req-text]').textContent = T('Choose a day and a time that suit you, in person or by video call. We will reply personally to confirm it.', 'اختر يوماً ووقتاً يناسبانك، حضوريّاً أو باتصالِ فيديو، وسنردُّ عليك شخصيّاً لتأكيده.');
      if (q('[data-a2-req-send]')) q('[data-a2-req-send]').textContent = T('Request my viewing', 'اطلب موعدَ المعاينة');
      var k = q('[data-a2-rf="kind"]'); if (k) k.value = 'Private viewing';
      var how = q('#A2RHow'); if (how) how.selectedIndex = 0;
      var p = q('[data-a2-req-saved]'); if (!p) return;
      var s = saved(); p.hidden = !s.length;
      if (s.length) p.textContent = T('We will prepare your saved pieces: ', 'سنُحضِّرُ لك القطعَ المحفوظة: ') + s.join(' · ');
    }, 60);
  });

  /* runs after the theme's own checks (bubbles to document last); skipped if a check stopped the form */
  document.addEventListener('submit', function (e) {
    var f = e.target; if (e.defaultPrevented || !f || !f.querySelector) return;
    var ft = f.querySelector('input[name="form_type"]'); if (!ft || ft.value !== 'contact') return;
    var get = function (n) { var i = f.querySelector('[name="contact[' + n + ']"]'); return i ? String(i.value || '').trim() : ''; };
    var kind = get('Enquiry') || get('Enquiry form') || 'Contact';
    var ref = get('Reference'); if (!ref) { ref = code(kind); hidden(f, 'contact[Reference]', ref); }
    var data = { v: 1, ref: ref, kind: kind, at: new Date().toISOString(), lang: AR ? 'ar' : 'en', page: location.pathname };
    Array.prototype.forEach.call(f.querySelectorAll('[name^="contact["]'), function (i) {
      var k = i.name.slice(8, -1); if (k === 'ORRA data' || k === 'body') return;
      if (i.type === 'checkbox' && !i.checked) return;
      if (i.closest('[hidden]')) return;
      var v = String(i.value || '').trim(); if (v && v !== '—') data[k] = v.slice(0, 600);
    });
    var body = get('body'); if (body && body !== '—') data.message = body.slice(0, 1500);
    if (/viewing|consult/i.test(kind)) { var s = saved(); if (s.length) { data.saved = s; hidden(f, 'contact[Saved pieces]', s.join(', ')); } }
    hidden(f, 'contact[ORRA data]', 'ORRA1' + JSON.stringify(data));
    try { sessionStorage.setItem('a2-last-ref', ref); } catch (x) {}
  });

  /* after sending: add the reference to the thank-you note */
  if (new URLSearchParams(location.search).get('contact_posted') === 'true') {
    var ref = ''; try { ref = sessionStorage.getItem('a2-last-ref') || ''; sessionStorage.removeItem('a2-last-ref'); } catch (x) {}
    if (ref) setTimeout(function () {
      var t = document.querySelector('[data-a2-toast]');
      if (t && t.textContent && t.textContent.indexOf(ref) < 0) {
        if (ref.indexOf('ORRA-V-') === 0) t.textContent = T('Thank you. We will reply personally to confirm your private viewing.', 'شكراً لك. سنردُّ عليك شخصيّاً لتأكيدِ موعدِ معاينتك.');
        t.textContent += ' ' + T('Your reference: ', 'رقمُ طلبك: ') + ref;
      }
      var ok = document.querySelector('.form-status--success span');
      if (ok && ok.textContent.indexOf(ref) < 0) ok.textContent += ' ' + T('Your reference: ', 'رقمُ طلبك: ') + ref;
    }, 900);
  }
})();
